/* ============================================================
   Bundle Discount add-on (Claude, Oct 2026) — TIERED version
   ------------------------------------------------------------
   Kept SEPARATE from the theme's own bundle code
   (sections/bundle-products.liquid and the theme JS are untouched).

   Tiers (bundle page only):
     3 items  ->  5% off
     4 items  -> 10% off
     5+ items -> 15% off

   1) Tagging: when the customer clicks "Add to bag" in the
      "Your bundle" panel, each item is sent to the cart with a
      hidden line property  _bundle = "Bundle Discount".
      Hidden properties (starting with _) are never shown to
      customers. The "Bundle Discount" app function gives the
      tier % off only to lines that carry this tag.

   2) Display: the "Your bundle" panel shows the tier ladder,
      items total, "Bundle Discount (x%)", the discounted total,
      "You save AED X" and how many more items unlock the next tier.

   Keep TIERS in sync with the discount function
   (extensions/bundle-discount/src/cart_lines_discounts_generate_run.js).
   To switch off: remove the two lines that load
   bundle-discount.css / bundle-discount.js in layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  // Lowest qty first. Keep in sync with the discount function.
  var TIERS = [
    { qty: 3, percent: 5 },
    { qty: 4, percent: 10 },
    { qty: 5, percent: 15 }
  ];
  var PROP_KEY = '_bundle';
  var PROP_VALUE = 'Bundle Discount';
  var LABEL = 'Bundle Discount';

  function money(cents) {
    try {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {
      return 'AED ' + (cents / 100).toFixed(2);
    }
  }

  function tierFor(count) {
    var found = null;
    TIERS.forEach(function (t) { if (count >= t.qty) found = t; });
    return found;
  }

  function nextTier(count) {
    for (var i = 0; i < TIERS.length; i++) {
      if (count < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  /* ---------- 1) Tag bundle items on "Add to bag" ---------- */
  // Capture phase on document runs before the theme's own submit
  // handler, which builds FormData(form) synchronously. We add
  // temporary items[n][...] inputs, disable the plain id[] inputs
  // for that one moment, then restore everything straight after.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('bundle-product-form')) return;

      var idInputs = Array.prototype.filter.call(
        form.querySelectorAll('input[name="id[]"]'),
        function (inp) { return !inp.disabled && inp.value; }
      );
      if (!idInputs.length) return;

      var added = [];
      idInputs.forEach(function (inp, i) {
        [
          ['items[' + i + '][id]', inp.value],
          ['items[' + i + '][quantity]', '1'],
          ['items[' + i + '][properties][' + PROP_KEY + ']', PROP_VALUE]
        ].forEach(function (pair) {
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = pair[0];
          h.value = pair[1];
          form.appendChild(h);
          added.push(h);
        });
        inp.disabled = true;
      });

      setTimeout(function () {
        added.forEach(function (h) { h.remove(); });
        idInputs.forEach(function (inp) { inp.disabled = false; });
      }, 0);
    },
    true
  );

  /* ---------- 2) Show the discount in the "Your bundle" panel ---------- */
  function ladderHtml(active) {
    return '<div class="bd-ladder">' + TIERS.map(function (t) {
      var on = active && active.qty === t.qty;
      var last = t === TIERS[TIERS.length - 1];
      return '<span class="bd-step' + (on ? ' is-on' : '') + '">' +
        '<b>' + t.percent + '% OFF</b><small>' + t.qty + (last ? '+' : '') + ' items</small></span>';
    }).join('') + '</div>';
  }

  function render(root) {
    var footer = root.querySelector('.bundle-product-cart-footer');
    var totalRow = root.querySelector('.bundle-product-cart-total');
    if (!footer || !totalRow) return;

    var items = root.querySelectorAll('.bundle-product-cart-items [have-product-data]');
    var count = items.length;
    var sum = 0;
    items.forEach(function (el) {
      sum += parseInt(el.getAttribute('data-product-price') || '0', 10) || 0;
    });

    var tier = sum > 0 ? tierFor(count) : null;
    var next = nextTier(count);
    var saving = tier ? Math.round((sum * tier.percent) / 100) : 0;
    var finalTotal = sum - saving;

    var box = root.querySelector('[data-bd-box]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'bd-box';
      box.setAttribute('data-bd-box', '');
      footer.insertBefore(box, totalRow);
    }
    var save = root.querySelector('[data-bd-save]');
    if (!save) {
      save = document.createElement('div');
      save.className = 'bd-save';
      save.setAttribute('data-bd-save', '');
      totalRow.insertAdjacentElement('afterend', save);
    }

    var html = ladderHtml(tier);
    if (tier) {
      html +=
        '<div class="bd-row"><span>Items total</span><span class="bd-strike">' + money(sum) + '</span></div>' +
        '<div class="bd-row bd-discount"><span>' + LABEL + ' (' + tier.percent + '%)</span><span>-' + money(saving) + '</span></div>';
    }
    if (next) {
      var need = next.qty - count;
      html += '<div class="bd-hint">Add ' + need + ' more item' + (need === 1 ? '' : 's') +
        ' to get ' + next.percent + '% off your bundle</div>';
    } else if (tier) {
      html += '<div class="bd-hint bd-hint-max">Top discount unlocked: ' + tier.percent + '% off</div>';
    }
    var saveHtml = tier ? '<span class="bd-pill">You save ' + money(saving) + '</span>' : '';

    if (box.innerHTML !== html) box.innerHTML = html;
    if (save.innerHTML !== saveHtml) save.innerHTML = saveHtml;
    root.classList.toggle('bd-active', !!tier);

    // Show the discounted total in the theme's own Total + button.
    // Only write when the text differs, so the observer doesn't loop.
    if (tier) {
      var totalEl = root.querySelector('[total-item-bundle-amount]');
      var btnEl = root.querySelector('[total-item-bundle-amount-btn]');
      var t = money(finalTotal);
      if (totalEl && totalEl.innerText !== t) totalEl.innerText = t;
      if (btnEl && btnEl.innerText !== t + ':') btnEl.innerText = t + ':';
    }
  }

  function init(root) {
    if (root.__bdInit) return;
    root.__bdInit = true;
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      // setTimeout (not requestAnimationFrame): rAF pauses in hidden tabs
      setTimeout(function () {
        queued = false;
        render(root);
      }, 30);
    };
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
    render(root);
  }

  function start() {
    document.querySelectorAll('bundle-products-card').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
